import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getFeedbacks } from '../../actions/feedback';
import FeedbackItem from './FeedbackItem';

const AllFeedbacks = ({
  auth,
  getFeedbacks,
  feedback: {feedbacks},
}) => {

  useEffect(() => {
    getFeedbacks();
  }, [getFeedbacks]);

  return (
    <div className='container'>
      <h4><i className='fa-light fa-comments' style={{color: 'var(--primary-color)'}} />&nbsp;User Feedbacks</h4>
      <Row xs={1} md={3} className="g-4">
          {feedbacks.map(feedback => (
              <FeedbackItem key={feedback._id} feedback={feedback} />
          ))}
      </Row>
    </div>
  )
};

AllFeedbacks.propTypes = {
  getFeedbacks: propTypes.func.isRequired,
  feedback: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
  feedback: state.feedback,
});

export default connect(mapStateToProps, { getFeedbacks })(AllFeedbacks);